/**
 * @file: 坐标系统
 * @author: xiaolong.huang@dmall.com
 */

import { scanAllCubes, deepScan } from './scanAllCube';
import {
    getInTargetLogicRectCubeIds,
    getRelativePhysicsCoordinate,
    getRelativeLogicCoordinate,
    getDiagonalRelativePhysicsCoordinate,
    getInTargetPaintRectCubeIds,
    getLogicCoordinateByType,
    getPaintCoordinateByType,
    getPhysicsRelative,
    filterByTargetPaintRect,
    findSameLeftCube
} from './advanceQuery';
import { add, update } from './add';
import { updateAllAsync, updateAllSync } from './update';
import {
    physicsToLogic,
    logicToPhysics,
    logicToPaint,
    paintToLogic,
    paintToPhysics,
    sketchpadPhysicsHeight
} from './transform';
import { sortByLeft } from './sort';
import Store from './store/index';

export default {
    scanAllCubes,
    deepScan,
    getInTargetLogicRectCubeIds,
    add,
    update,
    physicsToLogic,
    logicToPhysics,
    updateAllAsync,
    updateAllSync,
    getRelativePhysicsCoordinate,
    getRelativeLogicCoordinate,
    getDiagonalRelativePhysicsCoordinate,
    getInTargetPaintRectCubeIds,
    getLogicCoordinateByType,
    getPaintCoordinateByType,
    logicToPaint,
    paintToLogic,
    paintToPhysics,
    getPhysicsRelative,
    sortByLeft,
    filterByTargetPaintRect,
    sketchpadPhysicsHeight,
    findSameLeftCube,
    getPaintCoordinates: Store.getPaintCoordinates,
    getPaintCoordinate: Store.getPaintCoordinate,
    del: Store.del,
    delGroup: Store.delGroup,
    has: Store.has,
    clear: Store.clear,
    getPhysicsCoordinate: Store.getPhysicsCoordinate,
    getLogicCoordinate: Store.getLogicCoordinate,
    getAllLogicCoordinate: Store.getAllLogicCoordinate,
    getLogicCoordinates: Store.getLogicCoordinates
};
